import {
    BasicInfoBeneficiary,
    TermsBeneficiary,
    EvaluationFormBeneficiary,
    DocumentsBeneficiary
    } from './components';
    import { getLocalString, localNames } from "utils/localisation.service";
    import locale from 'antd/lib/date-picker/locale/el_GR';
  
  export const stepsAuditor = [
    {
      name: 'BASICFORM',
      label: 'Βασικά Στοιχεία',
      Component: BasicInfoBeneficiary,
      id: 0,
    },
    {
      name: 'DOCUMENTS',
      label: 'Έγγραφα',
      Component: DocumentsBeneficiary,
      id: 1,
    },
    {
      name: 'TERMS',
      label: 'Όροι και Προϋποθέσεις',
      Component: TermsBeneficiary,
      id: 2,
    },
    {
      name: 'EVALUATIONFORM',
      label: 'Αξιολόγηση από Φορέα Υλοποίησης',
      Component: EvaluationFormBeneficiary,
      id: 3,
    },
  ];